var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"mt-5",staticStyle:{"height":"150x"},attrs:{"cols":"12","align":"center"}},[_c('div',{staticStyle:{"padding-top":"100px","font-size":"32px"}},[_vm._v(" ユーザー認証中 ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }